import httpClient from '@/http-client'

export const dailySaleItem = data => {
  return httpClient
    .get('/api/v1/reports/daily-sale-items', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const dailySaleItemExcel = attributes => {
  return httpClient
    .post('/api/v1/reports/daily-sale-item-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const saleItemDetail = data => {
  return httpClient
    .get('/api/v1/reports/sale-item-details', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const stockInDetail = data => {
  return httpClient
    .get('/api/v1/reports/stock-in-details', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const stockInDetailExcel = attributes => {
  return httpClient
    .post('/api/v1/reports/stock-in-detail-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const stockInSummary = data => {
  return httpClient
    .get('/api/v1/reports/stock-in-summaries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const stockInSummaryExcel = attributes => {
  return httpClient
    .post('/api/v1/reports/stock-in-summary-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const detailInventoryList = data => {
  return httpClient
    .get('/api/v1/reports/detail-inventory-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const detailInventoryListToExcel = data => {
  return httpClient
    .post('/api/v1/reports/detail-inventory-lists-to-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const summaryInventoryList = data => {
  return httpClient
    .get('/api/v1/reports/summary-inventory-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const summaryInventoryListExcel = attributes => {
  return httpClient
    .post('/api/v1/reports/summary-inventory-list-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const productItemList = data => {
  return httpClient
    .get('/api/v1/reports/product-item-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const purchaseOrderList = data => {
  return httpClient
    .get('/api/v1/reports/purchase-order-details', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const purchaseOrderSummary = data => {
  return httpClient
    .get('/api/v1/reports/purchase-order-summaries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const monthlySaleItem = data => {
  return httpClient
    .post('/api/v1/reports/monthly-sale-items', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const monthlySaleItemExcel = attributes => {
  return httpClient
    .post('/api/v1/reports/monthly-sale-item-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const stockTransfer = data => {
  return httpClient
    .get('/api/v1/reports/stock-transfers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const stockTransferExcel = attributes => {
  return httpClient
    .post('/api/v1/reports/stock-transfers-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const yearlySaleItem = data => {
  return httpClient
    .get('/api/v1/reports/yearly-sale-items', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const productList  = ()  => {
  return httpClient
    .get('/api/v1/reports/inventory/product-lists')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const productSerial = data => {
  return httpClient
    .post('/api/v1/reports/inventory/product-serials', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  dailySaleItem,
  dailySaleItemExcel,
  saleItemDetail,
  stockInDetail,
  stockInDetailExcel,
  stockInSummary,
  stockInSummaryExcel,
  detailInventoryList,
  summaryInventoryList,
  productItemList,
  purchaseOrderList,
  purchaseOrderSummary,
  monthlySaleItem,
  stockTransfer,
  yearlySaleItem,
  monthlySaleItemExcel,
  stockTransferExcel,
  productList,
  productSerial,
  summaryInventoryListExcel,
  detailInventoryListToExcel
}
